import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const FormsIcon = createSvgIcon(
  <>
    <path d="M14.0833 5.41669H22.7499" {...strokeProps} />
    <path d="M14.0833 9.75H19.4999" {...strokeProps} />
    <path d="M14.0833 16.25H22.7499" {...strokeProps} />
    <path d="M14.0833 20.5833H19.4999" {...strokeProps} />
    <path
      d="M3.25 5.41665C3.25 5.12933 3.36414 4.85378 3.5673 4.65061C3.77047 4.44745 4.04602 4.33331 4.33333 4.33331H8.66667C8.95398 4.33331 9.22953 4.44745 9.4327 4.65061C9.63586 4.85378 9.75 5.12933 9.75 5.41665V9.74998C9.75 10.0373 9.63586 10.3128 9.4327 10.516C9.22953 10.7192 8.95398 10.8333 8.66667 10.8333H4.33333C4.04602 10.8333 3.77047 10.7192 3.5673 10.516C3.36414 10.3128 3.25 10.0373 3.25 9.74998V5.41665Z"
      {...strokeProps}
    />
    <path
      d="M3.25 16.25C3.25 15.9627 3.36414 15.6872 3.5673 15.484C3.77047 15.2808 4.04602 15.1667 4.33333 15.1667H8.66667C8.95398 15.1667 9.22953 15.2808 9.4327 15.484C9.63586 15.6872 9.75 15.9627 9.75 16.25V20.5834C9.75 20.8707 9.63586 21.1462 9.4327 21.3494C9.22953 21.5526 8.95398 21.6667 8.66667 21.6667H4.33333C4.04602 21.6667 3.77047 21.5526 3.5673 21.3494C3.36414 21.1462 3.25 20.8707 3.25 20.5834V16.25Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'FormsIcon', viewBox: '0 0 26 26' }
);
